
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/health-and-accidental",
      function () {
        return require("private-next-pages/products/health-and-accidental/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/health-and-accidental"])
      });
    }
  